import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-gb-options',
  templateUrl: './gb-options.component.html',
  styleUrls: ['./gb-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbOptionsComponent {}
